import type { StyleRule } from '@archipro-design/aria';
import {
    pxToRem,
    pxArrayToRem,
    archizeenTileClassName,
} from '@archipro-design/aria';

import { svgIconClassName } from '@archipro-design/icons';

export const Wrap: StyleRule = ({ theme }) => ({
    position: `relative`,
    padding: pxArrayToRem([0, 0, 75, 18]),

    [theme.screen.laptop]: {
        width: '100%',
        padding: 0,
    },
});

export const TitleWrap: StyleRule = ({ theme }) => ({
    marginBottom: pxToRem(10),

    [theme.screen.laptop]: {
        margin: 'auto',
        marginBottom: pxToRem(54),
        textAlign: 'center',
    },
});

export const MobileTitle: StyleRule = ({ theme }) => ({
    ...theme.siteVariables.textStyles.Heading.Roman55,
    textTransform: 'uppercase',
    marginBottom: pxToRem(20),
});

export const ButtonSlider: StyleRule = () => ({
    border: 'none',
    [`&.swiper-button-disabled`]: {
        opacity: 0.6,
        pointerEvents: `none`,
    },

    [`& > * > .${svgIconClassName}`]: {
        width: pxToRem(30),
        height: pxToRem(30),
    },
});

export const SliderWrap: StyleRule = () => ({
    overflow: 'hidden',
    margin: pxArrayToRem([0, -14]),
});

export const SlideInner: StyleRule = ({ theme }) => ({
    width: 'inherit',

    [theme.screen.clamped]: {
        width: 'inherit',
    },
});

export const SliderControls: StyleRule = () => ({
    marginTop: pxToRem(16),
    paddingRight: pxToRem(14),
});

export const Slide = () => ({
    whiteSpace: 'normal',
    //width: pxToRem(445.33),
    display: 'inline-block',
});

export const Slider = () => ({
    whiteSpace: 'nowrap',
    overflow: 'hidden',

    [`& > div`]: {
        display: `flex`,
    },
});

export const TileSlide: StyleRule = () => ({
    width: pxToRem(328),
    [`& .${archizeenTileClassName}`]: {
        padding: '0 !important',
    },
});

export const TileSlideWrap: StyleRule = () => ({
    width: 'fit-content',
    gap: pxToRem(14),
});

export const TileSlideOuterWrap: StyleRule = () => ({
    width: '100%',
    overflowX: 'auto',
    paddingRight: pxToRem(18),
    '&::-webkit-scrollbar': {
        height: 0,
    },
});
